import Widget from "./base.js";

export class BackchannelFormWidget extends Widget {
	componentDidMount() {
		var scriptEl = document.createElement("script");
		scriptEl.src = "https://sibforms.com/forms/end-form/build/main.js";
		scriptEl.defer = true;
		document.head.append(scriptEl);
		/* newspack unsets this, but SIB depends on this var being true
    this hack makes this component work on the frontpage */
		window._babelPolyfill = true;

		/* variables for SIB error messages */
		window.REQUIRED_CODE_ERROR_MESSAGE = "Please choose a country code";
		window.LOCALE = "en";
		window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE =
			"The information provided is invalid. Please review the field format and try again.";

		window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";

		window.GENERIC_INVALID_MESSAGE =
			"The information provided is invalid. Please review the field format and try again.";

		setTimeout(() => {
			this.setState({
				mounted: true,
			});
		}, 250);
	}

	renderContent() {
		if (this.hide) return;

		//this lets the stylesheet download, but visually hides things until the js has loaded in the componentDidMount method
		const style = {
			display: this.state.mounted ? "block" : "none",
		};
		return (
			<div class="BackchannelFormWidget__Inner" style={style}>
				<link
					rel="stylesheet"
					href="https://sibforms.com/forms/end-form/build/sib-styles.css"
				/>

				<div className="BackchannelFormWidget__Flex">
					<div className="BackchannelFormWidget__Title">THE BACKCHANNEL</div>
					<div className="BackchannelFormWidget__Free">FREE EDITION</div>
				</div>

				<div class="sib-form" style="text-align: center; padding: 4px 0;">
					<div id="sib-form-container" class="sib-form-container">
						<div
							id="error-message"
							class="sib-form-message-panel"
							style='font-size:16px; text-align:left; font-family:"Helvetica", sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;'
						>
							<div class="sib-form-message-panel__text sib-form-message-panel__text--center">
								<svg
									viewBox="0 0 512 512"
									class="sib-icon sib-notification__icon"
								>
									<path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
								</svg>
								<span class="sib-form-message-panel__inner-text">
									Your subscription could not be saved. Please try again.
								</span>
							</div>
						</div>
						<div></div>
						<div
							id="success-message"
							class="sib-form-message-panel"
							style='font-size:16px; text-align:left; font-family:"Helvetica", sans-serif; color:#085229; background-color:#e7faf0; border-radius:3px; border-color:#13ce66;max-width:540px;'
						>
							<div class="sib-form-message-panel__text sib-form-message-panel__text--center">
								<svg
									viewBox="0 0 512 512"
									class="sib-icon sib-notification__icon"
								>
									<path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
								</svg>
								<span class="sib-form-message-panel__inner-text">
									Your subscription has been successful.
								</span>
							</div>
						</div>
						<div id="sib-container" style="display:block; padding: 0;">
							<form
								id="sib-form"
								method="POST"
								action="https://179f7a4e.sibforms.com/serve/MUIEAENyBZI9d0ib6UFZgxi9r6XPZDEbK_-aLgJPms9sR40V00IAd2i929cyIMF17nCHVAGhkh_nsJy36OZpT1_3iFR-0KFyUiuFu9KEdl9xhuuyJ6DfXKVNV6mTgc2Ki2bJQCn22Z0Q-S6VA2eW1uR8Q8tkAE9S5sKODo-HOmB7TaSnG6vlLMWe4azRWnZFht1nAmZVgjQ2Z8Rv"
								data-type="subscription"
							>
								<div>
									<div
										class="sib-input sib-form-block"
										style="margin: 0; padding: 0;"
									>
										<div class="form__entry entry_block">
											<div
												class="form__label-row form__label-row--horizontal"
												style="align-items:unset; flex-direction: row !important;margin: 0; height:31px;"
											>
												<div
													class="entry__field"
													style="margin: 0; border: 0 none; border-radius: 0; border: 1px solid #333; border-right: 0 none;
    box-sizing: border-box;"
												>
													<input
														class="input "
														type="text"
														id="EMAIL"
														name="EMAIL"
														autocomplete="off"
														placeholder="Your email address"
														data-required="true"
														required
														style="font-family: Roboto"
													/>
												</div>

												<button
													class="sib-form-block__button sib-form-block__button-with-loader"
													style='font-size:17px; text-align:center; font-weight:normal; font-family:"Roboto", "Helvetica", sans-serif; color:#333333; background-color:#f8f6f1;  border: 1px solid #333; max-width: 140px; min-height: 31px;
                          height: 31px;
                          padding: 0 18px;
                          display: flex;
                          align-items: center;
                          justify-content: center;'
													form="sib-form"
													type="submit"
												>
													<svg
														class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon"
														viewBox="0 0 512 512"
													>
														<path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
													</svg>
													SIGN UP
												</button>
											</div>

											<label
												class="entry__error entry__error--primary"
												style='font-size:16px; text-align:left; font-family:"Helvetica", sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;'
											></label>
										</div>
									</div>
								</div>
								<input
									type="text"
									name="email_address_check"
									value=""
									class="input--hidden"
								/>
								<input type="hidden" name="locale" value="en" />
							</form>
						</div>
					</div>
				</div>

				<div className="BackchannelFormWidget__Flex">
					<div className="BackchannelFormWidget__New">NEW!</div>
					<div className="BackchannelFormWidget__Description">
						<span class="big">A FREE email newsletter from Josh Marshall</span>
						<span class="small">An email newsletter from Josh Marshall</span>
					</div>
				</div>

				{/* <script
          defer
          src="https://sibforms.com/forms/end-form/build/main.js"
        ></script> */}
			</div>
		);
	}
}
